// extracted by mini-css-extract-plugin
export default {"question":"FPmTFfMk","conclusion":"QIRExICr"};